"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChance = void 0;
var Chance = require("chance");
var getChance = function () { return new Chance('vod'); };
exports.getChance = getChance;
//# sourceMappingURL=chance.js.map